import {Serializable} from "@common/model/Serializable";
import {Document} from "@common/model/_adocument";

export class UploadDocument extends Document implements Serializable<UploadDocument> {

    isPanelOpen?: boolean;
    extension?: string;
    docFile?: any;
    calendarOpened?: boolean;
    size?: any;
    photoFile?: any;
    uplId?: string | number;
    postDate?: Date;
    documentFolderType?: any;
    displayedFileName?: string;

    constructor() {
        super();
    }

    deserialize(input: any) : this {
        super.deserialize(input);
        input.isPanelOpen && (this.isPanelOpen = input.isPanelOpen);
        input.extension && (this.extension = input.extension);
        input.docFile && (this.docFile = input.docFile);
        input.calendarOpened && (this.calendarOpened = input.calendarOpened);
        input.size && (this.size = input.size);
        input.photoFile && (this.photoFile = input.photoFile);
        input.uplId && (this.uplId = input.uplId);
        input.postDate && (this.postDate = new Date(input.postDate));
        input.documentFolderType && (this.documentFolderType = input.documentFolderType);
        input.displayedFileName && (this.displayedFileName = input.displayedFileName);
        return this;
    }


}
